var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Qty: "+_vm._s(_vm.totalQty)),_vm._l((this.product.shelfs.filter(function (x) { return x.qty > 0; })),function(shelf){return _c('span',{key:shelf.id},[_vm._v(", "+_vm._s(shelf.name)+": "+_vm._s(shelf.qty))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }